var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"client-section",class:_vm.isMobile? '' : 'desktop',attrs:{"elevation":"0"}},[_c('ClientCard',{attrs:{"isMobile":_vm.isMobile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }